import React from 'react';
export const PanelPickerContext = /*#__PURE__*/React.createContext({});
export const PanelPresetsContext = /*#__PURE__*/React.createContext({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/color-picker/context.js
// module id = 444
// module chunks = 0